import { FaRegDotCircle } from "react-icons/fa";

export default function ModalComponent({ data }) {
    return (
        <div className="container-fluid font-monospace">
            {/* <div className="h3 mb-3">Detail</div> */}
            <div className="row">
                <ModalDetail title="chromosome" text={data?.chromosome ?? '-'} />
                <ModalDetail title="position" text={data?.position ?? '-'} />
                <ModalDetail title="end" text={data?.end ?? '-'} />
                <ModalDetail title="favourable_allele" text={data?.favourable_allele ?? '-'} />
                <ModalDetail title="finger_printing" text={data?.finger_printing ?? '-'} />
                <ModalDetail title="marker_linkage" text={data?.marker_linkage ?? '-'} />
                <ModalDetail title="marker_name" text={data?.marker_name ?? '-'} />
                <ModalDetail title="marker_type" text={data?.marker_type ?? '-'} />
                <ModalDetail title="sequence" text={data?.sequence ?? '-'} />
                <ModalDetail title="source" text={data?.source ?? '-'} />
                <ModalDetail title="specificity" text={data?.specificity ?? '-'} />
                <ModalDetail title="start" text={data?.start ?? '-'} />
                <ModalDetail title="target_qtl" text={data?.target_qtl ?? '-'} />
                <ModalDetail title="trait_category" text={data?.trait_category ?? '-'} />
                <ModalDetail title="unfavourable_allele" text={data?.unfavourable_allele ?? '-'} />
                <ModalDetail title="rice_cultivar_th" text={data?.rice_cultivar_th ?? '-'} />
                <ModalDetail title="rice_cultivar_en" text={data?.rice_cultivar_en ?? '-'} />
            </div>
        </div>
    );
}

function ModalDetail({ title, text }) {
    return (
        <div className="col-12 col-md-6 col-xl-4 col-xxl-3 mb-4">
            <div className="fw-bold mb-2 d-flex align-items-center" style={{ fontSize: 18 }}>
                <div className="mx-2">
                    <FaRegDotCircle className="text-primary" />
                </div>
                <div>{title}</div>
            </div>
            <div className="bg-light p-1 rounded" style={{ marginLeft: 35, maxWidth: "100%", wordWrap: "break-word", fontFamily: "monospace" }}>
                {text}
            </div>
        </div>
    );
}
